import If from '../components/Shared/If/If';
import ToolTip from '../components/Shared/ToolTip/ToolTip';
import { TOOLTIP_POSITION_BOTTOM } from './dom-utils';
import React from 'react';
import { DeductionListItem } from '../components/DeductionList';
import { kebabCase } from 'lodash';
import { openModal } from '../redux/modules/modals/actions';
import { HelpButton } from '../components/Shared/HelpButton';
import classNames from 'classnames';
import { CONTACT_ACCOUNT_TEAM_MODAL } from '../redux/modules/modals/modals.module';

export const getUserState = (fund) => {
  const address = fund.address ? fund.address : {};

  return address.state;
};

export const getUserAddress = (fund) => {
  const address = fund.address ? fund.address : {};

  return address;
};

export const getIsStateWithholding = (fund, userStateWithholdingRules) => {
  return (
    userStateWithholdingRules.percent > 0 &&
    userStateWithholdingRules.mandatory &&
    ((userStateWithholdingRules.federalTaxDependent &&
      fund.IRAWithholding > 0) ||
      !userStateWithholdingRules.federalTaxDependent)
  );
};

export const expandedAutomatedTransactionStateWithholding = (
  fund,
  isStateWithholding,
  userStateWithholdingRules
) => {
  const state = getUserState(fund);
  return (
    <div className="expanded-automatic-transaction-withholding-container">
      Income Tax Withholding: Federal:{' '}
      <span className="expanded-automatic-transaction-withholding-amount">
        {fund.IRAWithholding > 0 ? fund.IRAWithholding : 'Declined'}
      </span>
      {fund.IRAWithholding > 0 ? '%' : ''}
      <If test={isStateWithholding || state === 'MN'}>
        ; State:{' '}
        <If test={state === 'MN'}>
          <span className="expanded-automatic-transaction-withholding-amount">
            Not Available
          </span>
        </If>
        <If test={state !== 'MN'}>
          <span className="expanded-automatic-transaction-withholding-amount">
            {userStateWithholdingRules.percent}
          </span>
          %
        </If>
      </If>
      <ToolTip
        message="The state withholding shown is the default amount per your applicable state's rules. This may not reflect individualized preferences (i.e., requested increased amount or a W&#8209;4R exemption)"
        placement={TOOLTIP_POSITION_BOTTOM}
      />
    </div>
  );
};

export const deductionListStateWithholdingNonMandatory = (
  RMData,
  userState,
  modal,
  ticker,
  dispatch
) => {
  return (
    <DeductionListItem
      className="state-taxes"
      value={
        RMData ? (
          <span>
            Call your{' '}
            <a
              className={`e2e-contact-account-team-${kebabCase(
                ticker
              )} deduction-list-federal-withholding-info`}
              id="contact-account-team"
              onClick={() =>
                dispatch(openModal(CONTACT_ACCOUNT_TEAM_MODAL, { RMData }))
              }
            >
              Account Team
            </a>{' '}
            for options
          </span>
        ) : (
          <span className="deduction-list-rm deduction-list-decline">
            Amount Not Available
          </span>
        )
      }
    >
      <React.Fragment>
        Estimated {userState === 'DC' && <span>Mandatory</span>} {userState}{' '}
        State Income Tax Withholding
        <HelpButton
          className={classNames(
            `e2e-state-withholding-non-mandatory-${kebabCase(ticker)}`,
            'deduction-list-federal-withholding-info'
          )}
          id="state-withholding-non-mandatory"
          onClick={() =>
            dispatch(
              openModal(modal, {
                caller: 'tooltip',
                state: userState,
              })
            )
          }
        />
      </React.Fragment>
    </DeductionListItem>
  );
};
